import invoker from"./invoker";export{Container_Type_Enum}from"./invoker";export default function getContainerType(){return invoker.getContainerType()}